"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterRoomActionHandler = exports.EnterRoomActionArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Registries_1 = require("../../state/Registries");
const IdArray_1 = require("../../utils/IdArray");
const Record_1 = require("../../../utils/Record");
const ActionType_1 = require("../ActionType");
class EnterRoomActionArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = ActionType_1.ActionType.EnterRoom;
        this.__typeName = "EnterRoom";
    }
}
exports.EnterRoomActionArgs = EnterRoomActionArgs;
let EnterRoomActionHandler = class EnterRoomActionHandler {
    activate(sequence, container, action) {
        if (container.hasCurrentRoom()) {
            container.dispatch(sequence, 0, new _1.ExitRoomActionArgs(container.currentRoom));
        }
        const room = (0, Record_1.getValueOrThrow)(container.rooms, action.args.roomId, "UNKNOWN_ROOM");
        container.setCurrentRoom(action.args.roomId);
        const enterSequence = sequence.pushSequence("parallel");
        for (const script of room.onEntered) {
            Registries_1.RoomScripts.getItem(script.key).run(enterSequence, container, room, script.args);
        }
        for (const actor of room.actors) {
            container.enableActor(enterSequence, actor);
        }
        const all = (0, IdArray_1.shuffle)([...container.allies, ...room.actors]);
        all.forEach((next, i) => {
            container.setTurnMeter(enterSequence, next, i * 10);
        });
        const sorted = all.sort((a, b) => container.getTurnMeter(a) - container.getTurnMeter(b));
        sorted.forEach((next, i) => sequence.push(new __1.UpdateTurnMeterVfxStepArgs(next, (i + 1) / sorted.length)));
        container.nextActor = sorted.at(-1);
        const eventSequence = sequence.pushSequence("parallel");
        container.emitEvent(eventSequence, container.adventure.id, new __1.RoomEnteredEventArgs(room.id));
        container.allies.forEach(ally => container.emitEvent(eventSequence, ally, new __1.RoomEnteredEventArgs(room.id)));
    }
};
EnterRoomActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.EnterRoom)
], EnterRoomActionHandler);
exports.EnterRoomActionHandler = EnterRoomActionHandler;
